import React, { useEffect, useState, useRef } from 'react';
import { Grid, Button, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  TableComponents,
  SimpleDialog,
  ButtonLoading,
  FilterPod,
  TimeMessageDg,
  ExportPodSpaceDg,
  TimelineDg,
  ReportOfflineTransactionActions,
  ConfirmDialog as WargignSpaceSize,
} from 'components';
import { enifyDateTime } from 'utility';
import { useExportFile, useCopy } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { columns } from './Columns';
import generateData from './generateData';
import InitFilters from './InitFiltering';
import { useNavigate } from 'react-router-dom';
import Services from '../../services/Services';
import ShareSerives from 'utility/ShareServices';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import {
  getExportWalletAndGuildUrl,
} from 'URLs';
const Content = ({ accountId }) => {
  // -- STATES --//
  const navigate = useNavigate();

  //====================================================================================

  const [filters, setFilters] = useState(InitFilters());
  const [filterParams, setFilterParams] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [isShowExport, setIsShowEport] = useState(false);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenShowExportDG, setIsOpenShowExportDG] = useState(false);
  const [isOpenTimetDG, setIsOpenTimetDG] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [timeRemain, setTimeRemain] = useState(0);
  const [isOpenTimeLineDg, setIsOpenTimeLineDg] = useState(false);
  const [timeLineLength, setTimeLineLength] = useState(0);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'exportReportGuildWalletDashboardBtn',
      'reportGuildWalletDashboardBtn',
      'exportListDetailActionBtn'
    ])
  const [actionItems, setActionItems] = useState([
    {
      title: 'دریافت فایل خروجی با پسوند xls',
      type: 'xls',
      status: '',
    },
    {
      title: 'دریافت فایل خروجی با پسوند csv',
      type: 'csv',
      status: '',
    },
    {
      title: 'درخواست فایل خروجی با پسوند pdf',
      type: 'pdf',
      status: 'offline',
    },
  ]);

  // -- HOOKS --//
  const classes = useStyle();
  const tableRef = useRef();
  const { downloadFile, isExporting } = useExportFile({
    url: getExportWalletAndGuildUrl(),
    filename: 'walletAndGuild-report',
  });
  useEffect(() => { }, []);
  const getList = async (query) => {
    setLoadingPage(true);
    try {
      const orderBy = [];
      const newFilters = [...filters];
      const filter = toFilterVOS([...newFilters]);
      const params = {
        page: query ? query?.pageNumber : page,
        size: query ? query?.pageSize : size,
        startYearMonth: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        endYearMonth: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };
      setFilterParams({ data, params });
      const res = await Services.getAllwalletAndGuild(data, params);
      reportOffileRequest();
      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query ? query?.pageSize : page,
        });
      }

      setLoadingPage(false);
      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoadingPage(true);
      } else {
        setLoadingPage(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  /**
   * گرفتن خروجی فایل
   * @param {pdf - excel} data
   */
  const onExportExeclAndCsv = (data) => {
    if (data.type == 'pdf') {
      // خروجی pdf
      reportOfflinePdf();
    } else {
      // خروجی اکسل
      downloadFile(data.type, filterParams?.data, filterParams?.params);
    }
  };

  /**
   * درخواست آفلاین فایل خروجی
   */
  const reportOfflinePdf = () => {
    const t = localStorage.getItem('talfighiTime');
    if (t) {
      const date1 = new Date(t);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const minuts = Math.ceil(diffTime / (1000 * 60)); // munits
      setTimeRemain(60 - minuts);
      if (minuts >= 60) {
        onExport();
      } else {
        setIsOpenTimetDG(true);
      }
    } else {
      onExport();
    }
  };

  /**
   * گرفتن خروجی pdf
   * @param {pdf} type
   */
  const onExport = (type) => {
    setIsLoadingExport(true);

    const p = {
      startYearMonth: filterParams?.params?.startYearMonth,
      endYearMonth: filterParams?.params?.endYearMonth,
    };
    Services.reportPdfWalletAndGuild(filterParams.data, p)
      .then((res) => {
        setIsOpenExportDG(true);
        reportOffileRequest();
        setIsLoadingExport(false);
      })
      .catch((error) => {
        setIsLoadingExport(false);
      });
  };

  const onShowExportUrl = () => {
    setIsShowEport(true);

    Services.getAddressExportFile()
      .then((res) => {
        setIsShowEport(false);
        window.open(res?.result);
        setIsOpenShowExportDG(false);
      })
      .catch((error) => {
        setIsShowEport(false);
      });
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  /**
   * کلیک بر روی دکمه لیست درخواست گزارشات در کامپوونت ReportOfflineTransactionActions
   */
  const onclickListReports = () => {
    navigate('/ReportOfflineTransactions?source=WalletAndGuild');
  };

  const reportOffileRequest = () => {
    setIsLoadingExport(true);

    const obj = {
      reportStatusKeys: ['TO_DO', 'DOING'],
      reportKeys: `WALLET_GUILD`,
    };
    ShareSerives.getRportOfflineRequest(obj)
      .then((res) => {
        setTimeLineLength(res?.count || 0);
        setIsLoadingExport(false);
      })
      .catch((error) => {
        setIsLoadingExport(false);
      });
  };
  useEffect(() => {
    !isOpenTimeLineDg && reportOffileRequest();
  }, [isOpenTimeLineDg]);
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
            {actionsList['reportGuildWalletDashboardBtn'] && (
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            )}
            {(actionsList['exportReportGuildWalletDashboardBtn'] || actionsList['exportListDetailActionBtn']) && (
              <ReportOfflineTransactionActions
                menuList={actionItems}
                onExport={onExportExeclAndCsv}
                loading={isExporting || isLoadingExport}
                onclickListReports={onclickListReports}
                setIsOpenTimeLineDg={setIsOpenTimeLineDg}
                timeLineLength={timeLineLength}
              />
            )}
          </Box>
          {actionsList['reportGuildWalletDashboardBtn'] && (
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )}
        </Grid>
        {actionsList['reportGuildWalletDashboardBtn'] && (
          <Grid item xs={12}>
            <TableComponents
              data={getList}
              columns={columns()}
              isLoading={loadingPage}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getList(ps);
              }}
            />
          </Grid>
        )}
      </Grid>
      <SimpleDialog fullWidth maxWidth="sm" open={isOpenShowExportDG} title="مشاهده فایل خروجی">
        <Grid container style={{ textAlign: 'justify' }}>
          برای مشاهده فایل، حداقل یک ساعت بعد از درخواست فایل خروجی به اکانت پاد اسپیس خود مراجعه
          فرمایید.
        </Grid>
        <Grid style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px', }}>
          <ButtonLoading
            variant="contained"
            color="primary"
            onClick={onShowExportUrl}
            loading={isShowExport}
            disabled={isShowExport}
            name="پاد اسپیس"
          />

          <Button
            variant="contained"
            onClick={() => setIsOpenShowExportDG(false)}
            style={{ marginRight: '8px' }}
          >
            بستن
          </Button>
        </Grid>
      </SimpleDialog>
      <TimeMessageDg
        isOpenTimetDG={isOpenTimetDG}
        setIsOpenTimetDG={setIsOpenTimetDG}
        timeRamain={timeRemain}
      />
      <ExportPodSpaceDg isOpenExportDG={isOpenExportDG} setIsOpenExportDG={setIsOpenExportDG} />
      <TimelineDg
        isOpenTimetDG={isOpenTimeLineDg}
        setIsOpenTimetDG={setIsOpenTimeLineDg}
        reportKey="WALLET_GUILD"
      />
    </>
  );
};

const useStyle = makeStyles((theme) => ({
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));
export default Content;
